//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'ABSI',
  data () {
    return {
      defaultJson: {
        "Prob. of Survival 50 - 70%": "存活概率：50 - 70%",
        "Full-thickness Burn": "全层烧伤",
        "Prob. of Survival 98%": "存活概率：98%",
        "Prob. of Survival ≥ 99%": "存活概率 ≥ 99%",
        "Prob. of Survival ≤ 10%": "存活概率 ≤ 10%",
        "Burned Area": "烧伤面积",
        "Prob. of Survival 20 - 40%": "存活概率：20 - 40%",
        "Inhalation Injury": "吸入性损伤",
        "Prob. of Survival 80 - 90%": "存活概率：80 - 90%",
        "Age": "年龄"
      },
      form: {
        gender:'',
        age:'',
        burned:'',
        inhalation:'0',
        fullThickness:'0',

      },
      hasScore: false,
      disabled: false,
      dataList1:[
        {value:"0",name:'男'},
        {value:"1",name:'女'},
      ],
      descTxt:'',
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log(form)
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        console.log(form)
        let result = (form.gender ? 1 : 0) + form.fullThickness + form.inhalation +Math.ceil(form.age / 20) +Math.ceil(form.burned / 10)
        if (result<=3) {
          self.descTxt = '存活概率 ≥ 99%'
        } else if (result<=5){
          self.descTxt = '存活概率：98%'
        }else if (result<=7){
          self.descTxt = '存活概率：80 - 90%'
        }else if (result<=9){
          self.descTxt = '存活概率：50 - 70%'
        }else if (result<=11){
          self.descTxt = '存活概率：20 - 40%'
        }else {
          self.descTxt = '存活概率 ≤ 10%'
        }
        self.hasScore = true
        return String(result)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Trauma/ABSI.vue